import { OrganizationBranding } from '../models/organization-branding.model';

export const DEFAULT_ORGANIZATION_BRANDING: OrganizationBranding = {
  logoUrl: '',
  placeholderLogoUrl: '/assets/logos/organization-placeholder.svg',
  theme: {
    mode: 'light',
    light: {
      primaryColor: '#0f172a',
      secondaryColor: '#1e40af',
      backgroundColor: '#f8fafc',
      surfaceColor: '#ffffff',
      borderColor: '#e2e8f0',
      textColor: '#0f172a',
      textMutedColor: '#64748b',
      sidebarBackgroundColor: '#ffffff',
      sidebarBorderColor: '#e2e8f0',
      sidebarTextColor: '#0f172a',
      sidebarTextMutedColor: '#64748b'
    },
    dark: {
      primaryColor: '#ffffff',
      secondaryColor: '#2563eb',
      backgroundColor: '#0a0a0a',
      surfaceColor: '#161616',
      borderColor: '#2a2a2a',
      textColor: '#ffffff',
      textMutedColor: '#a1a1aa',
      sidebarBackgroundColor: '#111111',
      sidebarBorderColor: '#222222',
      sidebarTextColor: '#ffffff',
      sidebarTextMutedColor: '#a1a1aa'
    }
  }
};
